import React from "react";
import FaqAccordion from "../faqAccordion/faqAccordion";

const Blog14 = ({ blog }) => {
  return (
    <div className="parent-container">
      <div className="main-container-blogpage" id="blog-content-container">
        <div className="category-tag">{blog.category}</div>
        <p className="headline-page">{blog.mainTitlePage}</p>
        <p className="date">{blog.publishDate}</p>

        <div className="image-container">
          <img className="img" src={blog.detailImage} alt={blog.imageAlt} />
        </div>

        {/* Introduction */}
        <p className="sub-paragraph-heading">Introduction</p>

        <p className="paragraph-content">
          With growing financial awareness and a rising middle class, more
          Indians are actively investing their money rather than leaving it idle
          in savings accounts. From traditional instruments to modern
          fintech-driven options, this guide explains popular investment options
          that make sense in 2026.
        </p>

        <p className="sub-paragraph-heading">
          1. Why Investing Is Becoming Popular in India
        </p>

        <p className="paragraph-content">
          India’s digital economy and rising disposable incomes are changing how
          people invest.
          <br />
          UPI transactions now account for a large share of digital payments,
          showing how deeply technology has penetrated everyday financial
          habits.
          <br />
          At the same time, rising household borrowing highlights the importance
          of balancing credit usage with smart investments.
        </p>

        <p className="sub-paragraph-heading">
          2. Equity & Mutual Funds — Long-Term Wealth Builders
        </p>

        <p className="paragraph-content">
          <b>Equity markets</b> remain one of the most attractive ways to grow
          wealth over time.
          <br />
          While short-term volatility is normal, equity and equity-linked mutual
          funds have historically outperformed many other instruments in the
          long run.
          <br />
          For beginners, <b>Systematic Investment Plans (SIPs)</b> are ideal
          because they:
        </p>

        <ul className="paragraph-content">
          <li>Spread risk over time</li>
          <li>Encourage disciplined investing</li>
          <li>Require low starting amounts</li>
        </ul>

        <p className="sub-paragraph-heading">
          3. Digital Gold — Easy & Accessible
        </p>

        <p className="paragraph-content">
          Digital gold allows investors to buy small fractions of gold online
          without storing physical jewelry.
          <br />
          It combines India’s traditional preference for gold with modern
          convenience.
        </p>

        <p className="sub-paragraph-heading">
          4. Fixed Deposits & Corporate Debentures
        </p>

        <p className="paragraph-content">
          Traditional instruments like <b>bank fixed deposits (FDs)</b> and
          <b> non-convertible debentures (NCDs)</b> still suit conservative
          portfolios.
          <br />
          Some NCDs are marketed with yields around <b>9% annual return</b>, but
          investors must check issuer credibility and credit ratings carefully.
        </p>

        <p className="sub-paragraph-heading">
          5. P2P Lending & Fintech Investment Apps
        </p>

        <p className="paragraph-content">
          Peer-to-peer (P2P) lending platforms connect investors directly with
          borrowers.
          <br />
          While returns can be higher than traditional banking instruments, risk
          is also higher.
          <br />
          Always diversify and evaluate platform credibility.
        </p>

        <p className="sub-paragraph-heading">
          6. Real Estate & Loan-Backed Investments
        </p>

        <p className="paragraph-content">
          Real estate remains a long-term wealth builder in India.
          <br />
          REITs and loan-against-property tools are making property exposure
          more accessible for smaller investors.
        </p>

        <p className="sub-paragraph-heading">
          7. Regulatory & Market Trends to Watch
        </p>

        <p className="paragraph-content">
          Regulatory support for digital banking and fintech lending continues
          to expand access to credit and investment channels.
          <br />
          Staying informed about policy updates helps investors make smarter
          decisions.
        </p>

        {/* FAQ */}
        <div className="faq-heading-container">
          <p className="sub-paragraph-heading-faq">
            Frequently asked questions
          </p>
        </div>

        <FaqAccordion>
          <h4 className="faq-question">
            What is the best investment option in India in 2026?
          </h4>
          <p className="faq-answer">
            There is no single “best” option. For beginners, SIPs in mutual
            funds are popular due to affordability and long-term growth
            potential.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">Is SIP better than fixed deposit?</h4>
          <p className="faq-answer">
            SIPs offer higher potential returns but come with market risk. Fixed
            deposits provide stable but usually lower returns compared to equity
            investments.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            How much should a beginner invest monthly?
          </h4>
          <p className="faq-answer">
            Many SIPs start from ₹500 per month. The right amount depends on
            income, expenses, and financial goals.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            Are digital investment apps safe in India?
          </h4>
          <p className="faq-answer">
            Apps regulated under Indian financial laws and partnered with
            registered institutions are generally safer. Always verify
            regulatory compliance before investing.
          </p>
        </FaqAccordion>

        <FaqAccordion>
          <h4 className="faq-question">
            What is the safest investment option in India?
          </h4>
          <p className="faq-answer">
            Government-backed instruments and fixed deposits are considered
            relatively safer, though returns are usually lower than equity
            investments.
          </p>
        </FaqAccordion>

        <br />
        <br />
      </div>
    </div>
  );
};

export default Blog14;
